<template>
  <div class="random-video">
    <!-- 随机视频按钮 -->
    <div class="random-video-btn">
      <el-tooltip class="box-item" effect="dark" content="随机视频播放" placement="right">
        <div @click="drawer = true">
          <i class="el-icon-d-arrow-right"></i>
        </div>
      </el-tooltip>
    </div>

    <!-- 抽屉组件 -->
    <el-drawer
        title="随机视频播放"
        :visible.sync="drawer"
        :with-header="false"
        :size="drawerSize"
        :wrapperClosable="true"
        :modal="true"
        :close-on-press-escape="true"
    >
      <div class="drawer-content">
        <!-- 视频播放器 -->
        <div class="video-container">
          <video
              ref="video"
              style="width: 100%; height: auto"
              controls
              autoplay
              :src="videoSrc"
              playsinline
              preload="metadata"
          ></video>
        </div>

        <!-- 操作按钮 -->
        <div class="button-container">
          <el-button type="primary" :icon="btnIcon" size="small" @click="operateVideo">
            {{ btnContent }}
          </el-button>
          <el-button type="primary" icon="el-icon-arrow-right" size="small" @click="nextVideo">下一个视频</el-button>
          <el-button type="danger" icon="el-icon-close" size="small" @click="drawer = false">关闭</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'RandomVideo',
  data() {
    return {
      drawer: false, // 控制抽屉的显示与隐藏
      videoSrc: 'http://api.yujn.cn/api/zzxjj.php', // 视频源地址
      isPlaying: true, // 视频播放状态
      btnContent: '暂停', // 播放/暂停按钮文本
      btnIcon: 'el-icon-video-pause', // 播放/暂停按钮图标
      drawerSize: '30%' // 抽屉默认宽度
    };
  },
  methods: {
    // 切换视频
    nextVideo() {
      this.videoSrc = this.videoSrc + "?temps=" + new Date().getTime();
    },
    // 播放/暂停视频
    operateVideo() {
      if (this.isPlaying) {
        this.$refs.video.pause();
        this.btnContent = '播放';
        this.btnIcon = 'el-icon-video-play';
        this.isPlaying = false;
      } else {
        this.$refs.video.play();
        this.btnContent = '暂停';
        this.btnIcon = 'el-icon-video-pause';
        this.isPlaying = true;
      }
    }
  },
  mounted() {
    // 根据屏幕宽度调整抽屉大小
    if (window.innerWidth <= 768) {
      this.drawerSize = '80%'; // 移动端抽屉宽度
    } else {
      this.drawerSize = '30%'; // PC 端抽屉宽度
    }
  }
};
</script>

<style scoped lang="scss">
.random-video-btn {
  position: fixed;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.5rem;
  color: #409eff;
  cursor: pointer;
  z-index: 10000; // 确保按钮在最上层
}

.drawer-content {
  padding: 16px;
  max-height: 90vh; // 限制抽屉最大高度
  overflow-y: auto; // 内容溢出时滚动
}

.video-container {
  padding: 8px;
  border-radius: 8px;
  max-height: 100vh; // 限制视频容器最大高度为视窗高度的60%
  video {
    border-radius: 8px;
    width: 100%;
    height: auto;
    max-height: 77vh; // 限制视频最大高度
    object-fit: contain; // 保持视频比例
  }
}

.button-container {
  margin-top: 10px;
  display: flex;
  gap: 10px; // 按钮之间的间距
  justify-content: center; // 水平居中
  align-items: center; // 垂直居中
}

@media (max-width: 768px) {
  .random-video-btn {
    font-size: 1.2rem;
    left: 5px;
    bottom: 10px;
  }

  .drawer-content {
    max-height: 80vh; // 移动端抽屉高度
  }

  .video-container {
    max-height: 60vh; // 移动端视频容器高度
    video {
      max-height: 50vh; // 移动端视频高度
    }
  }

  .button-container {
    flex-direction: column; // 移动端按钮垂直排列
    gap: 8px; // 增加按钮之间的间距
    width: 100%; // 确保容器占满宽度
    padding: 0 10px; // 添加左右内边距
  }

  .button-container .el-button {
    width: 100%; // 按钮占满容器宽度
  }
}
</style>